import { render, staticRenderFns } from "./export-xml.vue?vue&type=template&id=87e21a0c"
import script from "./export-xml.vue?vue&type=script&lang=js"
export * from "./export-xml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports